import { useState, useEffect, createRef } from "react";
import FetchUtil from "../../utils/FetchUtil";
import Select from 'react-select';
import { ddStyles } from "../../utils/CommonStyles.js";

let productGroupOptions = [];
const ProductFilter = ({ t, setErrorValue, onClickFilterCallback, defaultKeyword, defaultGroupKey }) => {

	const [refs] = useState({
		searchData: createRef(),
	});
	const [vars] = useState({
		searchData: defaultKeyword,
	});
	const [productGroupLoaded, setProductGroupLoaded] = useState(false);
	const [productGroupKey, setProductGroupKey] = useState(defaultGroupKey);
	const [productGroupSelected, setProductGroupSelected] = useState({ name: "productGroupKey", label: "", value: defaultGroupKey });

	useEffect(() => {
		fetchProductGroup();
	}, []);

	function fetchProductGroup() {
		setErrorValue("");
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("GetProductGroups", "/Service/StaticHelper/GetProductGroups", requestOptions, fetchProductGroupSuccess, fetchProductGroupFail);
		} catch (error) {
			throw new Error(error.message);
		}
	}

	function fetchProductGroupFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdGrpFailed"));
	}
	function fetchProductGroupSuccess(responseData) {
		let getProductGroupsResponse;
		if (responseData) {
			getProductGroupsResponse = responseData.getProductGroupsResponse;
			if (getProductGroupsResponse && getProductGroupsResponse.errorCode === "0") {
				setProductGroupValues(getProductGroupsResponse.productGroups);
			} else if (getProductGroupsResponse && getProductGroupsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getProductGroupsResponse) {
				setErrorValue(t("error.error") + " " + getProductGroupsResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}
	function setProductGroupValues(productGroupObj) {
		let productGroupValue = {};
		productGroupOptions = [];
		productGroupOptions.push({ label: "", value: 0 });
		if (productGroupObj && productGroupObj.length > 0) {
			productGroupObj.map((productGroup, index) => {
				productGroupValue.label = productGroup.productGroupName;
				productGroupValue.value = productGroup.productGroupKey;
				productGroupOptions.push(productGroupValue);
				productGroupValue = {};
			});
		}
		setProductGroupLoaded(true);
	}

	const productGroupHandler = (selectedOption, action) => {
		let selectedGroupKey = selectedOption ? selectedOption.value : 0;
		let selectedGroupName = selectedOption ? selectedOption.label : "";
		if (productGroupKey === selectedGroupKey) {
			return
		}

		setProductGroupKey(selectedGroupKey);
		setProductGroupSelected({ ...productGroupSelected, label: selectedGroupName, value: selectedGroupKey });
	}

	const onKeywordChange = (e) => {
		const { name, value } = e.target;
		//console.log(name + "  " + value);
		vars[name] = value;
	}
	const onClickSearch = () => {
		let searchValue = vars.searchData.trim();
		if(!productGroupKey || productGroupKey === 0){
			setErrorValue(t("error.prodGrp.Reqd"));
			return;
		}
		onClickFilterCallback(searchValue, productGroupKey, productGroupSelected.label);
	}
	const onClickClear = () => {
		refs.searchData.current.value = "";
		vars.searchData = "";
		if(!productGroupKey || productGroupKey === 0){
			setErrorValue(t("error.prodGrp.Reqd"));
			return;
		}
		onClickFilterCallback("", productGroupKey, productGroupSelected.label);
	}
	return (
		<div className="form-group search-box">
			<input
				id="searchData"
				name="searchData"
				ref={refs.searchData}
				defaultValue={vars.searchData}
				onChange={onKeywordChange}
				type="text"
				placeholder="Search Product"
				className="search-text"
			/>
			<div className="form-group search-dd">
				<label className="form-label">
				<span className="form_required">*</span>
					{t("page.productGrp")}
				</label>
				<Select
					name="productGroupKey"
					options={productGroupOptions}
					onChange={productGroupHandler}
					placeholder={""}
					value={productGroupSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="productGroupKey-input"
					styles={ddStyles}
				/>
			</div>
			<button
				type="submit"
				className="btn btn-primary btn-block search-button"
				onClick={onClickSearch}
			>
				<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
			</button>

			<button className="btn btn-primary btn-block search-clear" onClick={onClickClear}>{t("page.clear")}
			</button>
		</div>
	)
}

export default ProductFilter;